<div class="loading-container">
    <img src="assets/images/loading.gif"
         alt="loading..."
         class="loading-icon" />
    <div class="loading-text-wrapper">
        <!-- <p class="loading-text">Gathering your {{ title }}</p> -->
        <span class="loading-subheading" i18n="@@loadingDevices">This should only take a few moments...</span>
    </div>
</div>